/*
  S2S postback log: "Download for an ad platform" — conversions as a CSV
  for manual upload (GET /api/conversions/export-for-platform).
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Download for an ad platform": "Скачать для рекламной площадки",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Конверсии за период файлом для ручной загрузки. Попадают только конверсии, у клика которых есть click ID площадки (gclid, yclid, rb_clickid; для Meta — fbclid, fbc, e-mail или телефон).",
  "Ad platform": "Рекламная площадка",
  "Period": "Период",
  "Last {days} days": "Последние {days} дней",
  "Conversion name or goal (optional)": "Название конверсии или цель (необязательно)",
  "Downloaded conversions: {count}": "Скачано конверсий: {count}",
  "Could not prepare the file": "Не удалось подготовить файл",
  "Download CSV": "Скачать CSV",
};

const es = {
  "Download for an ad platform": "Descargar para una plataforma publicitaria",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Las conversiones del periodo en un archivo para subir a mano. Solo entran las conversiones cuyo clic tiene el click ID de la plataforma (gclid, yclid, rb_clickid; para Meta fbclid, fbc, e-mail o teléfono).",
  "Ad platform": "Plataforma publicitaria",
  "Period": "Periodo",
  "Last {days} days": "Últimos {days} días",
  "Conversion name or goal (optional)": "Nombre de la conversión u objetivo (opcional)",
  "Downloaded conversions: {count}": "Conversiones descargadas: {count}",
  "Could not prepare the file": "No se pudo preparar el archivo",
  "Download CSV": "Descargar CSV",
};

const pt = {
  "Download for an ad platform": "Baixar para uma plataforma de anúncios",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "As conversões do período em um arquivo para envio manual. Entram só as conversões cujo clique tem o click ID da plataforma (gclid, yclid, rb_clickid; para Meta fbclid, fbc, e-mail ou telefone).",
  "Ad platform": "Plataforma de anúncios",
  "Period": "Período",
  "Last {days} days": "Últimos {days} dias",
  "Conversion name or goal (optional)": "Nome da conversão ou meta (opcional)",
  "Downloaded conversions: {count}": "Conversões baixadas: {count}",
  "Could not prepare the file": "Não foi possível preparar o arquivo",
  "Download CSV": "Baixar CSV",
};

const de = {
  "Download for an ad platform": "Für eine Werbeplattform herunterladen",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Conversions des Zeitraums als Datei zum manuellen Hochladen. Enthalten sind nur Conversions, deren Klick die Klick-ID der Plattform hat (gclid, yclid, rb_clickid; für Meta fbclid, fbc, E-Mail oder Telefon).",
  "Ad platform": "Werbeplattform",
  "Period": "Zeitraum",
  "Last {days} days": "Letzte {days} Tage",
  "Conversion name or goal (optional)": "Conversion-Name oder Ziel (optional)",
  "Downloaded conversions: {count}": "Heruntergeladene Conversions: {count}",
  "Could not prepare the file": "Die Datei konnte nicht erstellt werden",
  "Download CSV": "CSV herunterladen",
};

const fr = {
  "Download for an ad platform": "Télécharger pour une plateforme publicitaire",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Les conversions de la période dans un fichier à importer à la main. Seules les conversions dont le clic a l’identifiant de clic de la plateforme sont incluses (gclid, yclid, rb_clickid ; pour Meta fbclid, fbc, e-mail ou téléphone).",
  "Ad platform": "Plateforme publicitaire",
  "Period": "Période",
  "Last {days} days": "{days} derniers jours",
  "Conversion name or goal (optional)": "Nom de la conversion ou objectif (facultatif)",
  "Downloaded conversions: {count}": "Conversions téléchargées : {count}",
  "Could not prepare the file": "Impossible de préparer le fichier",
  "Download CSV": "Télécharger le CSV",
};

const it = {
  "Download for an ad platform": "Scarica per una piattaforma pubblicitaria",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Le conversioni del periodo in un file da caricare a mano. Sono incluse solo le conversioni il cui clic ha il click ID della piattaforma (gclid, yclid, rb_clickid; per Meta fbclid, fbc, e-mail o telefono).",
  "Ad platform": "Piattaforma pubblicitaria",
  "Period": "Periodo",
  "Last {days} days": "Ultimi {days} giorni",
  "Conversion name or goal (optional)": "Nome della conversione o obiettivo (facoltativo)",
  "Downloaded conversions: {count}": "Conversioni scaricate: {count}",
  "Could not prepare the file": "Impossibile preparare il file",
  "Download CSV": "Scarica CSV",
};

const pl = {
  "Download for an ad platform": "Pobierz dla platformy reklamowej",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Konwersje z okresu w pliku do ręcznego przesłania. Trafiają tylko konwersje, których kliknięcie ma click ID platformy (gclid, yclid, rb_clickid; dla Meta fbclid, fbc, e-mail lub telefon).",
  "Ad platform": "Platforma reklamowa",
  "Period": "Okres",
  "Last {days} days": "Ostatnie {days} dni",
  "Conversion name or goal (optional)": "Nazwa konwersji lub cel (opcjonalnie)",
  "Downloaded conversions: {count}": "Pobrane konwersje: {count}",
  "Could not prepare the file": "Nie udało się przygotować pliku",
  "Download CSV": "Pobierz CSV",
};

const tr = {
  "Download for an ad platform": "Reklam platformu için indir",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Dönemin dönüşümleri elle yüklemek için dosya olarak. Yalnızca tıklamasında platformun tıklama kimliği olan dönüşümler dahil edilir (gclid, yclid, rb_clickid; Meta için fbclid, fbc, e-posta veya telefon).",
  "Ad platform": "Reklam platformu",
  "Period": "Dönem",
  "Last {days} days": "Son {days} gün",
  "Conversion name or goal (optional)": "Dönüşüm adı veya hedef (isteğe bağlı)",
  "Downloaded conversions: {count}": "İndirilen dönüşüm: {count}",
  "Could not prepare the file": "Dosya hazırlanamadı",
  "Download CSV": "CSV indir",
};

const uk = {
  "Download for an ad platform": "Завантажити для рекламного майданчика",
  "Conversions of the period as a file for manual upload. Only conversions whose click has the platform click id are included (gclid, yclid, rb_clickid; for Meta fbclid, fbc, e-mail or phone).": "Конверсії за період файлом для ручного завантаження. Потрапляють лише конверсії, у кліка яких є click ID майданчика (gclid, yclid, rb_clickid; для Meta — fbclid, fbc, e-mail або телефон).",
  "Ad platform": "Рекламний майданчик",
  "Period": "Період",
  "Last {days} days": "Останні {days} днів",
  "Conversion name or goal (optional)": "Назва конверсії або ціль (необовʼязково)",
  "Downloaded conversions: {count}": "Завантажено конверсій: {count}",
  "Could not prepare the file": "Не вдалося підготувати файл",
  "Download CSV": "Завантажити CSV",
};

const PLATFORM_EXPORT = { ru, es, pt, de, fr, it, pl, tr, uk };
export default PLATFORM_EXPORT;
